import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  type CheckboxProps,
} from '@mui/material'
import {
  Controller,
  type Control,
  type FieldValues,
  type Path,
} from 'react-hook-form'

interface FormInputProps<T extends FieldValues> extends CheckboxProps {
  control: Control<T>
  name: Path<T>
  label?: React.ReactNode
}

export const FormCheckbox = <T extends FieldValues>({
  control,
  name,
  label,
  ...props
}: FormInputProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormControl
          error={!!fieldState.error}
          sx={{ alignItems: 'flex-start' }}
        >
          <FormControlLabel
            control={
              <Checkbox
                {...props}
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                inputRef={field.ref}
              />
            }
            label={label}
          />
          {fieldState.error && (
            <FormHelperText>{fieldState.error.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}
